
import { Component, Inject, inject } from '@angular/core';
import { ModalConfirmationDeleteAccountService } from './service/modal-confirmation-delete-account.service';
import { ModalConfirmationDeleteInputCodeService } from '../modal-confirmation-delete-input-code/service/modal-confirmation-delete-input-code.service';
import { ModalConfirmationDeleteInputCodeComponent } from '../modal-confirmation-delete-input-code/modal-confirmation-delete-input-code.component';
import { DeleteAccountService } from '../delet-account/service/delete-account.service';
import { NotificationsService } from '../../../../shared/components/notifications/service/notifications.service';


@Component({
  selector: 'perfil-user-component-modal-confirmation-delete-account',
  imports: [ModalConfirmationDeleteInputCodeComponent],
  templateUrl: './modal-confirmation-delete-account.component.html',
  styleUrl: './modal-confirmation-delete-account.component.css'
})
export class ModalConfirmationDeleteAccountComponent {
  modalConfirmationDeleteInputCodeService = inject(ModalConfirmationDeleteInputCodeService);
  modalConfirmationDeleteAccountService = inject(ModalConfirmationDeleteAccountService);
  DeleteAccountService=inject(DeleteAccountService);
  notificationsService = inject(NotificationsService);
  onCloseModal() {
    this.modalConfirmationDeleteAccountService.closeModal();
  }

  confirmDeleteAccount() {
    this.DeleteAccountService.deleteAccount().subscribe({
      next: (response) => {
        if (response.status) {
          this.notificationsService.addNotification(  {
            message: 'Código enviado a su correo electrónico',
            type: 'success',
            duration: 3000
          })
          this.modalConfirmationDeleteAccountService.closeModal();
        }
      },
    });
    this.modalConfirmationDeleteInputCodeService.openModal();
  }
}
